import { MenuItem } from '@material-ui/core';
import { ChangeEvent, ReactElement, useState } from 'react';
import { Licence } from '../../../redux';
import { ITextInputFieldProps, TextInputField } from '../../atoms';

export interface ILicenceFieldProps {
	licences: Licence[];
}

export function LicenceField<T>(
	props: ITextInputFieldProps<T> & ILicenceFieldProps
): ReactElement {
	const { name, control, required, label, licences } = props;
	const [licenceSelectOpen, setLicenceSelectOpen] = useState<boolean>(false);

	function onLicenceSelected(
		changeHandler: (event: ChangeEvent<HTMLInputElement>) => void
	): (event: ChangeEvent<HTMLInputElement>) => void {
		return (event: ChangeEvent<HTMLInputElement>) => {
			setLicenceSelectOpen(false);
			changeHandler(event);
		};
	}

	return (
		<TextInputField
			name={name}
			control={control}
			required={required}
			label={label}
			onSelect={onLicenceSelected}
			onClick={() => setLicenceSelectOpen(!licenceSelectOpen)}
			select
			selectProps={{ multiple: true, open: licenceSelectOpen }}
			className="licence-field"
			fullWidth
		>
			{licences.map((licence: Licence, index: number) => (
				<MenuItem key={index} value={licence.id}>
					{licence.name}
				</MenuItem>
			))}
		</TextInputField>
	);
}
